export const getProfessionalInitials = (name: string): string => {
  const parts = name.trim().split(/\s+/).filter(Boolean);

  if (parts.length === 0) {
    return "?";
  }

  if (parts.length === 1) {
    return parts[0].slice(0, 2).toUpperCase();
  }

  return `${parts[0][0] ?? ""}${parts[parts.length - 1][0] ?? ""}`.toUpperCase();
};

export const normalizeHexColor = (value: string, fallback = "#6C757D"): string => {
  const trimmed = value.trim();

  if (!trimmed) {
    return fallback;
  }

  const hex = trimmed.replace(/^#/, "");

  if (!/^[0-9A-Fa-f]{6}$/.test(hex)) {
    return fallback;
  }

  return `#${hex.toUpperCase()}`;
};

export const getReadableTextColor = (hexColor: string): string => {
  const hex = hexColor.replace(/^#/, "");
  const red = parseInt(hex.slice(0, 2), 16);
  const green = parseInt(hex.slice(2, 4), 16);
  const blue = parseInt(hex.slice(4, 6), 16);
  const luminance = (0.299 * red + 0.587 * green + 0.114 * blue) / 255;

  return luminance > 0.62 ? "#212529" : "#FFFFFF";
};

export const resolvePublicStorageUrl = (path?: string | null): string | null => {
  if (!path?.trim()) {
    return null;
  }

  if (path.startsWith("http://") || path.startsWith("https://")) {
    return path;
  }

  const apiUrl = (process.env.REACT_APP_API_URL || "http://localhost:8000/api/v1").replace(/\/$/, "");
  const origin = apiUrl.replace(/\/api\/v1$/i, "");

  return `${origin}/storage/${path.replace(/^\//, "")}`;
};
